import { moveElementInArray } from "../../helpers"
import { useState } from "react"

export const useTechnicalSpecificationsDragAndDrop = ({ getIndicatorsByLabel, updateIndicatorsByLabel }) => {
  const [indicatorsToUpdateOrderIndex, setIndicatorsToUpdateOrderIndex] = useState({})
  const [activitiesToUpdateOrderIndex, setActivitiesToUpdateOrderIndex] = useState({})
  const [indicatorsToCreateOrderIndex, setIndicatorsToCreateOrderIndex] = useState({})
  const [activitiesToCreateOrderIndex, setActivitiesToCreateOrderIndex] = useState({})

  const handeDragEnd = ({ source, destination }) => {
    if (!source || !destination) return
    if (source.droppableId === destination.droppableId && source.index === destination.index) return
    if (source.droppableId.includes("INDICATOR") && destination.droppableId.includes("ACTIVITY")) return
    if (destination.droppableId.includes("INDICATOR") && source.droppableId.includes("ACTIVITY")) return

    const modifiedIndicatorOrderIndex = JSON.parse(JSON.stringify(indicatorsToUpdateOrderIndex))
    const createdIndicatorOrderIndex = JSON.parse(JSON.stringify(indicatorsToCreateOrderIndex))

    if (destination.droppableId !== source.droppableId) {
      const sourceDataArray = (source.droppableId || "").split("_")
      const sourceLabel = sourceDataArray[0]
      const indicatorType = INDICATOR_TYPE_LABEL[sourceDataArray[1]]
      const sourceSpecificObjectiveIndex = sourceDataArray[2] ? +sourceDataArray[2] : undefined

      const sourceIndicatorsArray = getIndicatorsByLabel({
        indicatorType,
        specificObjectiveIndex: sourceSpecificObjectiveIndex
      })[sourceLabel]()

      const uploadedSourceIndicatorsArray = (sourceIndicatorsArray || []).filter((_, index) => index !== source.index)

      const sortedSourceIndicatorsArray = uploadedSourceIndicatorsArray.map((el, index) => ({
        ...el,
        orderIndex: index + 1
      }))

      const draggedElement = {
        ...sourceIndicatorsArray[source.index],
        orderIndex: destination.index + 1
      }

      const destinationDataArray = (destination.droppableId || "").split("_")
      const destinationLabel = destinationDataArray[0]
      const destinationSpecificObjectiveIndex = destinationDataArray[2] ? +destinationDataArray[2] : undefined

      const destinationIndicatorsArray = getIndicatorsByLabel({
        indicatorType,
        specificObjectiveIndex: destinationSpecificObjectiveIndex
      })[destinationLabel]()

      destinationIndicatorsArray
        .splice(destination.index, 0, draggedElement)

      const sortedDestinationIndicatorsArray = destinationIndicatorsArray.map((el, index) => ({
        ...el,
        orderIndex: index + 1
      }))

      const updatedOrderIndexOnIndicators = [
        ...sortedSourceIndicatorsArray,
        ...sortedDestinationIndicatorsArray
      ]

      if ((indicatorType || "").includes("indicators")) {
        updatedOrderIndexOnIndicators.forEach(indicator => {
          if (!indicator.id) {
            createdIndicatorOrderIndex[indicator.tempId] = indicator.orderIndex
            return
          }
          modifiedIndicatorOrderIndex[indicator.id] = indicator.orderIndex
        })
        setIndicatorsToCreateOrderIndex(createdIndicatorOrderIndex)
        setIndicatorsToUpdateOrderIndex(modifiedIndicatorOrderIndex)
      }

      if ((indicatorType || "").includes("activities")) {
        const modifiedActivitiesOrderIndex = JSON.parse(JSON.stringify(activitiesToUpdateOrderIndex))
        const createdActivitiesOrderIndex = JSON.parse(JSON.stringify(activitiesToCreateOrderIndex))

        updatedOrderIndexOnIndicators.forEach(activity => {
          if (!activity.id) {
            createdActivitiesOrderIndex[activity.tempId] = activity.orderIndex
            return
          }
          modifiedActivitiesOrderIndex[activity.id] = activity.orderIndex
        })

        setActivitiesToCreateOrderIndex(createdActivitiesOrderIndex)
        setActivitiesToUpdateOrderIndex(modifiedActivitiesOrderIndex)
      }

      updateIndicatorsByLabel({
        indicatorType,
        specificObjectiveIndex: sourceSpecificObjectiveIndex
      })[sourceLabel](sortedSourceIndicatorsArray)

      updateIndicatorsByLabel({
        indicatorType,
        specificObjectiveIndex: destinationSpecificObjectiveIndex
      })[destinationLabel](sortedDestinationIndicatorsArray)

      return {
        updateTechnicalSpecifications: true,
        objectiveIndicatorsToUpdate: {
          [source.droppableId]: sortedSourceIndicatorsArray,
          [destination.droppableId]: sortedDestinationIndicatorsArray
        }
      }
    }
    if (destination.droppableId === source.droppableId) {
      const destinationDataArray = (destination.droppableId || "").split("_")
      const destinationLabel = destinationDataArray[0]
      const indicatorType = INDICATOR_TYPE_LABEL[destinationDataArray[1]]
      const destinationSpecificObjectiveIndex = destinationDataArray[2] ? +destinationDataArray[2] : undefined

      const destinationIndicatorsArray = getIndicatorsByLabel({
        indicatorType,
        specificObjectiveIndex: destinationSpecificObjectiveIndex
      })[destinationLabel]()

      const sortedIndicatorsArray =
        moveElementInArray(destinationIndicatorsArray, source.index, destination.index)

      const updatedOrderIndex = sortedIndicatorsArray
        .map((indicator, index) => ({ ...indicator, orderIndex: index + 1 }))

      updateIndicatorsByLabel({
        indicatorType,
        specificObjectiveIndex: destinationSpecificObjectiveIndex
      })[destinationLabel](updatedOrderIndex)

      if ((indicatorType || "").includes("indicators")) {
        updatedOrderIndex.forEach(indicator => {
          if (!indicator.id) {
            createdIndicatorOrderIndex[indicator.tempId] = indicator.orderIndex
            return
          }
          modifiedIndicatorOrderIndex[indicator.id] = indicator.orderIndex
        })

        setIndicatorsToCreateOrderIndex(createdIndicatorOrderIndex)
        setIndicatorsToUpdateOrderIndex(modifiedIndicatorOrderIndex)
        return
      }
      if ((indicatorType || "").includes("activities")) {
        const modifiedActivitiesOrderIndex = JSON.parse(JSON.stringify(activitiesToUpdateOrderIndex))
        const createdActivitiesOrderIndex = JSON.parse(JSON.stringify(activitiesToCreateOrderIndex))

        updatedOrderIndex.forEach(activity => {
          if (!activity.id) {
            createdActivitiesOrderIndex[activity.tempId] = activity.orderIndex
            return
          }
          modifiedActivitiesOrderIndex[activity.id] = activity.orderIndex
        })

        setActivitiesToCreateOrderIndex(createdActivitiesOrderIndex)
        setActivitiesToUpdateOrderIndex(modifiedActivitiesOrderIndex)
      }

      return {
        updateTechnicalSpecifications: true,
        objectiveIndicatorsToUpdate: {
          [source.droppableId]: sortedSourceIndicatorsArray,
          [destination.droppableId]: sortedDestinationIndicatorsArray
        },
        movedIndicator: {
          id: draggedElement.id,
          indicatorType,
          sourceLabel,
          destinationLabel
        }
      }
    }
  }

  const clearSorterIndicators = () => {
    setIndicatorsToUpdateOrderIndex({})
    setActivitiesToUpdateOrderIndex({})
  }

  return {
    handeDragEnd,
    clearSorterIndicators,
    indicatorsToCreateOrderIndex,
    activitiesToCreateOrderIndex,
    indicatorsToUpdateOrderIndex,
    activitiesToUpdateOrderIndex
  }
}

const INDICATOR_TYPE_LABEL = {
  INDICATOR: "indicators",
  ACTIVITY: "activities"
}
